import ResultsListItemWithState from "../../../js/datasets/search/ResultsListItem";

export default ResultsListItemWithState;
